export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/logo-marquee.ae888672-a25611.png";